module.exports = __webpack_public_path__ + "img/DE00742.eaefbda0.png";